import { render, staticRenderFns } from "./PressPage.vue?vue&type=template&id=32552a00&scoped=true"
import script from "./PressPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PressPage.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./PressPage.vue?vue&type=style&index=0&id=32552a00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32552a00",
  null
  
)

export default component.exports